import { render, staticRenderFns } from "./DeviceTable2.vue?vue&type=template&id=d7c318ce&scoped=true&"
import script from "./DeviceTable2.vue?vue&type=script&lang=js&"
export * from "./DeviceTable2.vue?vue&type=script&lang=js&"
import style0 from "./DeviceTable2.vue?vue&type=style&index=0&id=d7c318ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7c318ce",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
